<template>
  <section class="content">
    <div class="map" @click="mapClick">
      <div ref="container" class="owlly-map" :style="{ opacity:opacity / 100 }"></div>
      <img v-if="imageUrl" :src="imageUrl" class="leica">
    </div>
    <div class="option">
      <div>
        <div style="margin:8px 0px">
          <el-button type="primary" size="mini" @click="save">保存</el-button>
        </div>
        <!-- <div style="margin:8px 0px"><el-button type="primary" size="mini" @click="align">转换</el-button></div> -->
        <div class="img-box">
          <el-upload class="avatar-uploader"
                     :action="action"
                     :show-file-list="false"
                     :on-success="handleAvatarSuccess"
                     :before-upload="beforeAvatarUpload">
            <img v-if="imageUrl" :src="imageUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </div>
        <el-slider v-if="imageUrl" v-model="opacity" />
        <div class="leftBox">
          <i @click="setZoom('out')">
            <svg-icon icon-class="scalePlus" class="scalePlus" />
          </i>
          <i @click="setZoom('in')">
            <svg-icon icon-class="scaleMinus" class="scaleMinus" />
          </i>
          <i @click="setRotate('left')">
            <svg-icon icon-class="rotateLeft" class="rotateLeft" />
          </i>
          <i @click="setRotate('right')">
            <svg-icon icon-class="rotateRight" class="rotateRight" />
          </i>
          <!-- <i @click="$emit('download3DImage')">
            <svg-icon icon-class="uploadSvg" class="downloadSvg" />
          </i> -->
        </div>
        <div>
          <p>对齐后点击地图</p>
          <p v-if="3-steps>0">点击<span style="color:red">{{3-steps}}</span>次完成</p>
          <p v-else>矩阵输出完成</p>
        </div>
        <json-viewer theme="my-awesome-json-theme" copyable :value="formData.matrix"></json-viewer>
      </div>
    </div>
  </section>
</template>
<script>
import JsonViewer from 'vue-json-viewer';
import * as math from 'mathjs';
import { getPlacesInfo, queryGis, updateGis } from '@/api/map';
import { OwllyStage } from './stage';


export default {
  name: 'MapImageAlign',
  components: {
    JsonViewer,
  },
  computed: {
    place_id() {
      return this.$route.query.place_id;
    },
    floor_id() {
      return this.$route.query.floor_id;
    },
  },
  data() {
    return {
      file: '',
      imageUrl: '',
      opacity: 100,
      action: 'https://ali-openfaas.aibee.cn/function/deployment-service/floor/upload_img_file',
      formData: {
        image_width: 0,
        image_height: 0,
        matrix: [],
      },
      picPoints: [],
      mapPoints: [],
      steps: 0,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      const { data } = await getPlacesInfo({ place_id: this.place_id });
      const place = data[0];
      const floor = place.floors.find(i => i.id === parseInt(this.floor_id, 10));
      this.place = place;
      this.floor = floor;
      this.initMap();
      await this.stage.initFloor(this.floor.floor_cmap, JSON.parse(this.floor.floor_cmap_align_param));
      this.initData();
    },
    async initData() {
      const gisInfo = await queryGis({
        params: {
          floor_id: this.floor_id,
        },
      });
      this.gisInfo = gisInfo.data.algin_param;
      if (!Array.isArray(gisInfo.data.algin_param) && gisInfo.data.algin_param.leica_align) {
        this.imageUrl = gisInfo.data.algin_param.leica_align.imageUrl;
        delete gisInfo.data.algin_param.leica_align.imageUrl;
        this.formData = gisInfo.data.algin_param.leica_align;
        if (gisInfo.data.algin_param.leica_align.zoom && gisInfo.data.algin_param.leica_align.position && gisInfo.data.algin_param.leica_align.rotate) {
          this.stage.setZoom(gisInfo.data.algin_param.leica_align.zoom);
          this.stage.setCenter(gisInfo.data.algin_param.leica_align.position[0], gisInfo.data.algin_param.leica_align.position[1]);
          this.stage.setRotate(gisInfo.data.algin_param.leica_align.rotate);
        }
      }
      console.log(this.formData);
    },
    // 初始化地图
    async initMap() {
      if (!this.stage) {
        this.stage = new OwllyStage({
          container: this.$refs.container,
          dpr: 1,
          rotateEnable: true,
          mapClick: (e) => {
            console.log(e);
          },
        });
        this.stage.init();
      }
    },
    mapClick(e) {
      if (!this.imageUrl) {
        this.$message('请上传图片资源');
        return;
      }
      const page = { x: e.offsetX, y: e.offsetY };
      const proportion = this.formData.image_width / this.formData.image_height;
      const picPosition = [];
      if (proportion > 1) {
        picPosition.push(page.x / 800 * this.formData.image_width);
        picPosition.push((page.y - (800 - 800 / proportion) / 2) / (800 / proportion) * this.formData.image_height);
      } else {
        picPosition.push((page.x - (800 - 800 * proportion) / 2) / (800 * proportion) * this.formData.image_width);
        picPosition.push(page.y / 800 * this.formData.image_height);
      }
      picPosition.push(1);
      const mapPosition = this.stage.stageClick(e);
      if (this.picPoints.length === 3) {
        this.picPoints = [];
        this.mapPoints = [];
        this.formData.matrix = [];
        this.steps = 0;
      }
      this.picPoints.unshift(picPosition);
      this.mapPoints.unshift(mapPosition);
      console.log(this.picPoints, this.mapPoints);
      this.steps += 1;
      if (this.picPoints.length === 3) {
        this.calc();
      }
    },
    setZoom(key) {
      let zoom = this.stage.getZoom();
      if (key === 'out') {
        zoom += 0.02;
      } else {
        zoom -= 0.02;
      }
      this.stage.setZoom(zoom);
    },
    setRotate(key) {
      let rotate = this.stage.getRotate();
      if (key === 'right') {
        rotate += 0.005;
      } else {
        rotate -= 0.005;
      }
      this.stage.setRotate(rotate);
    },
    calc() {
      let pointsA = this.picPoints;
      let pointsB = this.mapPoints;
      pointsA = math.transpose(pointsA);
      pointsB = math.transpose(pointsB);

      if (math.det(pointsA) === 0) {
        console.error('not invertible');
        return;
      }
      const invA = math.inv(pointsA);
      const result = math.multiply(pointsB, invA);

      this.formData.matrix = result;
    },
    handleAvatarSuccess(res, file) {
      if (res.error_no === 0) {
        this.imageUrl = res.data;
        const img = new Image();
        img.src = this.imageUrl;
        img.onload = (e) => {
          console.log('img', img.width);
          console.log('加载完成');
          this.formData.image_width = img.width;
          this.formData.image_height = img.height;
          console.log(img.width, img.height);
        };
        this.$message({
          type: 'success',
          message: '上传OSS服务成功',
        });
      } else {
        this.$message({
          type: 'fail',
          message: '上传OSS服务失败',
        });
      }
    },
    beforeAvatarUpload(file) {
      const img = file.type.includes('image');
      this.file = file;
      if (!img) {
        this.$message.error('请上传图片!');
      }
      return img;
    },
    async save() {
      if (!this.formData.matrix || this.formData.matrix.length <= 0) {
        this.$message.info('请对齐后保存');
        return;
      }
      this.$confirm('确认保存', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async (e) => {
        const target = {
          data: {
            floor_id: this.floor_id,
            algin_param: {
              ...this.gisInfo,
            },
          },
        };
        target.data.algin_param.leica_align = this.formData;
        target.data.algin_param.leica_align.imageUrl = this.imageUrl;
        target.data.algin_param.leica_align.zoom = this.stage.getZoom();
        target.data.algin_param.leica_align.position = this.stage.getCenter();
        target.data.algin_param.leica_align.rotate = this.stage.getRotate();
        const { error_no } = await updateGis(target);
        if (error_no === 0) {
          this.$message.success('保存成功');
        }
      }).catch((e) => {
        console.log(e);
      });
    },
    // align() {
    //   let point = math.multiply(this.formData.matrix, math.matrix([[239], [95], [1]]));
    //   point = point.toArray();
    //   console.log(point);
    // },

  },
};
</script>
<style scoped lang="scss">
.content {
  position: relative;
  display: flex;
  overflow: hidden;
  height: calc(100vh - 46px);
  justify-content: space-between;
  padding-right: 16px;
  .map {
    position: relative;
    width: 800px;
    height: 800px;
  }
  .owlly-map {
    left: 0;
    top: 0;
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 1;
  }
  .leica {
    left: 0;
    top: 0;
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  .img-box {
    width: 100px;
    height: 100px;
  }
  .avatar-uploader {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    margin: 8px 8px;
    font-size: 28px;
    color: #8c939d;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
    border: 1px solid #409eff;
  }
  .avatar {
    width: 80px;
    height: 80px;
    display: block;
    margin: 8px;
  }
  .option {
    width: 240px;
  }
  .leftBox {
    width: 100%;
    user-select: none;
    .svg-icon {
      fill: #000;
      font-size: 14px;
      width: 30px;
      height: 30px;
      margin-right: 10px;
      cursor: pointer;
      &:hover {
        fill: #307bf6;
      }
    }
  }
}
</style>
